import { Number, Partial, Record, Static, String } from "runtypes";

export const SeasonRuntype = Record({
  name: String,
  order: Number,
  schoolId: Number,
  startDate: Number,
}).And(
  Partial({
    id: Number,
  })
);

export interface ISeasonData extends Static<typeof SeasonRuntype> {}

export interface ISeason extends Static<typeof SeasonRuntype> {
  id: number;
}



// WEBPACK FOOTER //
// ./src/api/types/ISeason.ts